export default __webpack_public_path__ + "static/icecream-taste-3-mobile-309be4bcd92fab0bde4a1398ec045844.png";